var map = {
	"./404.svg": "a14a",
	"./admin.svg": "ced6",
	"./arrow-down.svg": "1033",
	"./arrow-left.svg": "12e3",
	"./arrow-right.svg": "6929",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./comment.svg": "03ee",
	"./component.svg": "56d6",
	"./create-user.svg": "d3b6",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./dollar.svg": "c952",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./folder-open.svg": "6f95",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./layout.svg": "ebfe",
	"./like.svg": "c814",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./loading.svg": "d412",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./open-tab.svg": "b7ce",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./qq.svg": "1430",
	"./role.svg": "520c",
	"./search.svg": "8e8d",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./warning.svg": "7e6f",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";